import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { REGEX } from 'src/app/constants/regex';
import { HttpService, UtilityService } from 'src/app/services';
import { DataService } from 'src/app/services/data.service';
import { CustomValidations } from '../../../custom-validations';
import { LoginErrorComponent } from 'src/app/components/global-dialog/auth-dialog/login-error/login-error.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  isLoading: boolean = false;
  submitted: boolean;
  listItem;
  @Output() signUpSuccess = new EventEmitter<string>();
  hide=true;
  confirmPasshide=true;
  matcher = new MyErrorStateMatcher();
  signUp: FormGroup;
    
  constructor(private fb: FormBuilder,private util: UtilityService, private data: DataService, private router: Router, private route: ActivatedRoute,
    private http: HttpService, private snackbar: MatSnackBar, public dialog: MatDialog) { 
      localStorage.removeItem('FlightLoginToken');
  }

  onTabChange() {
    this.signUp.markAsPristine();  // Mark form as pristine on tab change
    this.signUp.markAsUntouched(); // Mark form as untouched on tab change
  }

  ngOnInit(): void {
    this.signUp = this.fb.group({
      name: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, Validators.pattern(REGEX.EMAIL)]),
      mobile: new FormControl('', [Validators.required, Validators.pattern(REGEX.MOBILE)]),
      password: new FormControl('', [Validators.required]),
      repeat_password: new FormControl('', Validators.required),
    }, { validators: CustomValidations.MatchPassword,
      // updateOn: 'submit'  // Validation happens only on submit
    });
  }

  submit() {
    if(this.signUp.valid) {
      this.isLoading = true;
      this.http.flightsave(`apiV2/auth/signup`, this.signUp.value).subscribe(res=>{
        if(res.statusCode === 200){
          this.listItem = 'Successfully registered, Please login.';
          // this.util.showMsg('Successfully Registered');
          this.isLoading = false;
          this.signUpSuccess.emit(this.listItem);  // Emit the success event
          setTimeout(() => {
            this.signUp.reset();
            this.signUp.clearValidators();
          }, 3000); // 3000 milliseconds = 3 seconds
          // this.http.hotelsave(`auth/user-registration`, this.signUp.value).subscribe(res=>{
          //   if(res.statusCode === 200){
          //   }
          // },err=>{this.util.errorMessage(err);})
        }
      },err => {
        this.isLoading = false;
        this.util.errorMessage(err);
        this.listItem = err?.error?.data?.errors?.email;
        // this.util.errorMessage(err);
        // this.dialog.open(LoginErrorComponent, {
        //   data: this.listItem,
        //   width: '420px',
        //   panelClass: 'login-dialog-container'
        // });
      });










      // this.http.hotelsave(`auth/user-registration`, this.signUp.value).subscribe(
      //   res => {
      //     if (res.status_code === 200) {
      //       this.snackbar.open('Successfully Register', 'Success', {
      //         duration: 3000,
      //         panelClass: ['RegisterSuccessfully'],
      //         horizontalPosition: 'end',
      //         verticalPosition: 'top',
      //       });
      //       location.reload();
      //       this.signUp.reset();

      //     } else if (res.status_code !== 200) {
      //         if(res.error_desc.email){
      //         this.snackbar.open('Email Address has already been taken', 'Failed', {
      //           duration: 3000,
      //       });
      //       } else if (res.error_desc.mobile){
      //         this.snackbar.open('Mobile Number has already been taken', 'Failed', {
      //           duration: 3000,
      //         });
      //       }
      //       // else if (res.error_desc.email || res.error_desc.mobile ){
      //       //   this.snackbar.open('Email & Mobile Number has already been taken', 'Failed', {
      //       //     duration: 3000,
      //       //   });
      //       // }
      //       // console.log(res.error_desc);
      //     }
      //   },

      // );
      // this.http.flightsave(`apiV2/auth/signup`, this.signUp.value).subscribe(res => {
      //   if(res.statusCode === 200) {
      //     this.snackbar.open(res.message, 'Success'), {
      //       duration: 3000,
      //       horizontalPosition: 'center',
      //       verticalPosition: 'bottom',
      //     }
      //   }
      // })
    }
  }

}
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const invalidCtrl = !!(control?.invalid && control?.parent?.dirty);
    const invalidParent = !!(control?.parent?.invalid && control?.parent?.dirty);
    return invalidCtrl || invalidParent;
  }
}
